'use strict';
module.exports = function googleTokenRefresher(metadataSynchronizer, authenticationModel) {
	metadataSynchronizer.addEventListener('fail', function (reason) {
		if (reason === 'not-authenticated') {
			authenticationModel.backgroundAuthenticate();
		}
	});
};
